var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"text-center",attrs:{"value":_vm.loading.stats,"z-index":"250"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('h4',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.loading.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }